// extracted by mini-css-extract-plugin
module.exports = {"mask":"UserModal_mask__bVfzc","modal":"UserModal_modal__lSygn","wallet":"UserModal_wallet__rJLiO","equity":"UserModal_equity__X7319","equityIcon":"UserModal_equityIcon__bwM9g"};